
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.002 24a3.736 3.736 0 01-2.039-.606 3.755 3.755 0 01-1.101-5.188L7.478 8.028V1.5h-.75a.75.75 0 010-1.5h10.5a.75.75 0 010 1.5h-.75v6.528l6.616 10.179c.396.61.606 1.316.606 2.043a3.73 3.73 0 01-1.098 2.652A3.728 3.728 0 0119.95 24H4.002zM2.12 19.024a2.253 2.253 0 001.883 3.477H19.95c.601 0 1.166-.234 1.591-.659a2.244 2.244 0 00.295-2.817l-3.59-5.524H5.71l-3.59 5.523zM17.271 12l-2.172-3.341a.75.75 0 01-.121-.409V7.5h-2.25a.75.75 0 010-1.5h2.25V4.5h-2.25a.75.75 0 010-1.5h2.25V1.5h-6v6.75a.75.75 0 01-.121.409L6.685 12h10.586z"}}),_c('path',{attrs:{"d":"M15.728 19.5a.75.75 0 01-.75-.75V18h-.75a.75.75 0 010-1.5h.75v-.75a.75.75 0 011.5 0v.75h.75a.75.75 0 010 1.5h-.75v.75a.75.75 0 01-.75.75zM6.727 20.625a.748.748 0 01-.133-.012 1.126 1.126 0 01-.98-.982.717.717 0 01-.001-.262c.06-.513.47-.922.983-.983a.796.796 0 01.258 0c.514.059.924.469.985.983a.717.717 0 010 .262c-.06.512-.468.921-.98.982a.704.704 0 01-.132.012zM9.727 17.625a.748.748 0 01-.133-.012 1.126 1.126 0 01-.98-.982.717.717 0 01-.001-.262c.06-.513.47-.922.983-.983a.796.796 0 01.26 0c.568.066.995.542.995 1.114a.817.817 0 01-.013.139 1.128 1.128 0 01-.979.974.704.704 0 01-.132.012z"}})])
          )
        }
      }
    